import React, { Component } from 'react';
import { AiOutlineMail } from 'react-icons/ai';

export default class ContactUs extends Component {
  render() {
    return (
      <section id="contact" style={{ textAlign: 'center' }}>
        <div className="row section-head">
          <div className="twelve columns">
            <p className="lead">Contact us:</p>
          </div>
        </div>
        <div className="row">
          <aside className="twelve columns">
            <div className="widget">
              <h4>
                <a href="mailto:contact@pythonicit.com" style={{ fontSize: "26px"}}>
                  <AiOutlineMail />
                  contact@pythonicit.com
                </a>
              </h4>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}
